/**
 * Survives a page reload mid-recognition. Mobile browsers can silently
 * discard a background tab during the camera hand-off or an orientation
 * change, wiping whatever JS state was tracking an in-flight recognition
 * call even though the relay finishes the request fine. Persisting just the
 * captured photo means a reload costs a retry, not a re-shoot.
 */

const KEY_PREFIX = 'mahjong-scorer:pendingScan:';
const MAX_AGE_MS = 60 * 60 * 1000; // stale after an hour — not worth resurrecting

export interface PendingScan {
  photo: string;
  timestamp: number;
}

export function savePendingScan(tableId: string, photo: string): void {
  localStorage.setItem(KEY_PREFIX + tableId, JSON.stringify({ photo, timestamp: Date.now() }));
}

export function loadPendingScan(tableId: string): PendingScan | undefined {
  const raw = localStorage.getItem(KEY_PREFIX + tableId);
  if (!raw) return undefined;

  let parsed: PendingScan;
  try {
    parsed = JSON.parse(raw) as PendingScan;
  } catch {
    localStorage.removeItem(KEY_PREFIX + tableId);
    return undefined;
  }

  if (Date.now() - parsed.timestamp > MAX_AGE_MS) {
    localStorage.removeItem(KEY_PREFIX + tableId);
    return undefined;
  }
  return parsed;
}

export function clearPendingScan(tableId: string): void {
  localStorage.removeItem(KEY_PREFIX + tableId);
}
